import { render, staticRenderFns } from "./floatField.vue?vue&type=template&id=5219ed39&lang=pug&"
import script from "./floatField.vue?vue&type=script&setup=true&lang=js&"
export * from "./floatField.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports